(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.AccessController = (function(superClass) {
    extend(AccessController, superClass);

    function AccessController(access_name, http) {
      this.access_name = access_name;
      this.http = http;
      this.http.get('backend/admin/access/user-pages').then((function(_this) {
        return function(response) {
          if (!response.data.includes(_this.access_name)) {
            return window.location.replace('admin');
          }
        };
      })(this));
    }

    return AccessController;

  })(Controller);

}).call(this);
